import { BaseDomainModel } from '../models/base/base-domain-model';
import { TransactionsAPI } from '../api/transactions-api';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Transaction } from '../models/transactions/transaction';
import { TypeService } from '../services/type/type-service';
import { TransactionEntryCodeType } from '../models/transactions/transaction-entry-code-type';
import { RemittanceTransaction } from '../models/transactions/remittance-transaction';
import { ODataQueryOptions } from '../models/shared/odata-query-options';
import { TransactionEntry } from '../models/transactions/transaction-entry';
import { ODataResponse } from '../models/protocols/odata-response';

@Injectable()
export class TransactionDomainModel extends BaseDomainModel {
  constructor() {
    super();
    this.init();
  }

  private transactionsAPI = inject(TransactionsAPI);
  private typeService = inject(TypeService);

  private _entryCodeTypes = new BehaviorSubject<TransactionEntryCodeType[]>([]);
  public entryCodeTypes$ = this._entryCodeTypes as Observable<TransactionEntryCodeType[]>;

  public init(): void {
    this.fetchEntryTypes();
  }

  public fetchTransactionById(id: number): Observable<Transaction> {
    return this.transactionsAPI.fetchInternalTransactionById(id);
  }

  private fetchEntryTypes(): void {
    this.typeService.transactionEntryCodeTypes$.once(entryCodeTypes => this._entryCodeTypes.next(entryCodeTypes));
  }

  public getTransactionsForRemittance(remittanceId: number): Observable<RemittanceTransaction[]> {
    return this.transactionsAPI.getTransactionsForRemittance(remittanceId);
  }

  public getInternalTransactionEntriesForMemberAccount(
    memberId: number,
    memberAccountId: number,
    odataQueryOptions = new ODataQueryOptions()
  ): Observable<ODataResponse<TransactionEntry>> {
    return this.transactionsAPI.getInternalTransactionEntriesForMemberAccount(
      memberId,
      memberAccountId,
      odataQueryOptions
    );
  }

  public getIPTransactionEntriesForTransaction(
    transactionId: number,
    odataQueryOptions = new ODataQueryOptions()
  ): Observable<ODataResponse<TransactionEntry>> {
    return this.transactionsAPI.getIPTransactionEntriesForTransaction(transactionId, odataQueryOptions);
  }
}
